import styled from '@emotion/styled';

import COLOR from '../../../../../../shared/constant/colorset';

const ValueWrapper = styled.dd`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const Value = styled.p`
  color: ${COLOR.kurlyGray800};
  line-height: 19px;
  white-space: pre-line;
  word-break: break-all;
  overflow: hidden;
`;

const AddText = styled.p`
  display: block;
  font-size: 12px;
  color: ${COLOR.kurlyGray600};
  padding-top: 4px;
  line-height: 16px;
  white-space: pre-line;
`;

interface Props {
  value: string | string[];
  addText?: string;
}

export default function ItemValue({ value, addText }: Props) {
  return (
    <ValueWrapper>
      {!Array.isArray(value)
        ? (<Value>{value}</Value>)
        : value.map((item: string) => (
          <Value key={item}>
            -
            {' '}
            {item}
          </Value>
        ))}
      {addText && <AddText>{addText}</AddText>}
    </ValueWrapper>
  );
}
